module.exports = __webpack_public_path__ + "img/newslatter_default.97b84792.jpg";